
<template>
    <div class="searchresults" :class="{ show: activeWindow }">
        <div v-if="loading && accomodations.length == 0">
            <div class="post" v-for="_ in 5">
                <div class="avatar"></div>
                <div class="line"></div>
                <div class="line"></div>
            </div>
        </div>
        <div v-else-if="!loading && accomodations.length > 0">
            <div class="post" v-for="(item, _) in accomodations" @click='selectResult($event, item)'>
                <div class="avatar">
                    <object v-if="item.hasOwnProperty('nonHome') & item.nonHome == 'propertyType'" class="icon"
                        v-bind:data="currentUrl + '/images/icons/propTypes/' + item.name + '.svg'"
                        :title="item.name"></object>
                    <object v-else-if="item.hasOwnProperty('nonHome')" class="icon"
                        v-bind:data="currentUrl + '/images/icons/' + item.nonHome + '.svg'" :title="item.nonHome"></object>
                    <img v-else v-bind:src="mipmap(item.spotlightimage, 100)">
                </div>
                <div class="line" :class="{ nonHome: item.hasOwnProperty('nonHome') }" v-if="item.nonHome == 'country'">
                    {{ item.name }}
                    <span v-bind:class="'fi fi-' + item.key.toLowerCase()"></span>
                </div>
                <div class="line" :class="{ nonHome: item.hasOwnProperty('nonHome') }" v-else>{{ item.name }}</div>
                <div v-if="!item.hasOwnProperty('nonHome')" class="line">{{ item.city }}, {{ item.state }}</div>
                <a v-if="!item.hasOwnProperty('nonHome')" class="goToHome flex justify-center items-center"
                    :href="currentUrl + '/accomodations/' + item.id">
                    <div class="arrow right"></div>
                </a>
            </div>
        </div>
        <div v-else-if="JSON.parse(this.cache_acco).length > 5">
            <div class="post" @click="selectResult($event, { key: 'NL', name: 'Netherlands', nonHome: 'country' })">
                <div class="avatar">
                    <object class="icon" v-bind:data="currentUrl + '/images/icons/country.svg'"
                        title="The Netherlands"></object>
                </div>
                <div class="line nonHome">
                    The Netherlands
                    <span class="fi fi-nl"></span>
                </div>
            </div>
            <div class="post" @click="selectResult($event, { key: 'ES', name: 'Spain', nonHome: 'country' })">
                <div class="avatar">
                    <object class="icon" v-bind:data="currentUrl + '/images/icons/country.svg'" title="Spain"></object>
                </div>
                <div class="line nonHome">
                    Spain
                    <span class="fi fi-es"></span>
                </div>
            </div>
            <div class="post" @click="selectResult($event, { key: 'GR', name: 'Greece', nonHome: 'country' })">
                <div class="avatar">
                    <object class="icon" v-bind:data="currentUrl + '/images/icons/country.svg'" title="Greece"></object>
                </div>
                <div class="line nonHome">
                    Greece
                    <span class="fi fi-gr"></span>
                </div>
            </div>
            <div class="post" @click="selectResult($event, { key: 'PT', name: 'Portugal', nonHome: 'country' })">
                <div class="avatar">
                    <object class="icon" v-bind:data="currentUrl + '/images/icons/country.svg'" title="Portugal"></object>
                </div>
                <div class="line nonHome">
                    Portugal
                    <span class="fi fi-pt"></span>
                </div>
            </div>
            <div class="post" @click="selectResult($event, { key: 'IT', name: 'Italy', nonHome: 'country' })">
                <div class="avatar">
                    <object class="icon" v-bind:data="currentUrl + '/images/icons/country.svg'" title="Italy"></object>
                </div>
                <div class="line nonHome">
                    Italy
                    <span class="fi fi-it"></span>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="post" v-for="(item, _) in JSON.parse(this.cache_acco)" @click='selectResult($event, item)'>
                <div class="avatar">
                    <object v-if="item.hasOwnProperty('nonHome') & item.nonHome == 'propertyType'" class="icon"
                        v-bind:data="currentUrl + '/images/icons/propTypes/' + item.name + '.svg'"
                        :title="item.name"></object>
                    <object v-else-if="item.hasOwnProperty('nonHome')" class="icon"
                        v-bind:data="currentUrl + '/images/icons/' + item.nonHome + '.svg'" :title="item.nonHome"></object>
                    <img v-else v-bind:src="mipmap(item.spotlightimage, 100)">
                </div>
                <div class="line" :class="{ nonHome: item.hasOwnProperty('nonHome') }" v-if="item.nonHome == 'country'">
                    {{ item.name }}
                    <span v-bind:class="'fi fi-' + item.key.toLowerCase()"></span>
                </div>
                <div class="line" :class="{ nonHome: item.hasOwnProperty('nonHome') }" v-else>{{ item.name }}</div>
                <div v-if="!item.hasOwnProperty('nonHome')" class="line">{{ item.city }}, {{ item.state }}</div>
                <a v-if="!item.hasOwnProperty('nonHome')" class="goToHome flex justify-center items-center"
                    :href="currentUrl + '/accomodations/' + item.id">
                    <div class="arrow right"></div>
                </a>
            </div>
        </div>
        <a v-bind:href="`${currentUrl}/accomodations/`">
            <div class="more">
                Show all
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: 'searchResults',
    props: ['loading', 'accomodations', 'currentUrl', 'activeWindow', 'cache_acco'],
    methods: {
        mipmap(src, res) {

            if (src.includes('https://media.xmlcal.com')) {
                var imgblocks = src.split("/");
                var imgfile = imgblocks[imgblocks.length - 1];
                var thumbnailimgsmall =
                    imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
                imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
                return imgblocks.join("/");
            } else {
                return src;
            }
        },
        selectResult(event, item) {
            if (!event.target.classList.contains('goToHome') && !event.target.classList.contains('arrow')) {
                this.$emit('locationSelect', item)
            }
        }
    }
}
</script>